import React, { useRef, useEffect } from 'react'
import lock from '../../../assets/logos/icons-lock.png'
import unlock from '../../../assets/logos/icons-unlock.png'
import p5 from 'p5'
import { useTranslation } from 'react-i18next'
import { SignatureUtil } from '../../../utils'

// Mantener fuera de la instancia de p5, pero no crear referencias infinitas
let validation = { activeOnSubit: false }
let deleteButton = 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/sign/botebasura.svg'
let padlockLocked = 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/sign/padlock_locked.svg'
let padlickUnlocket = 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/sign/padlock_unlocked.svg'

/**
 * @export
 * @param {{tFunction: import('i18next').TFunction, widthImg: number, heightImg: number, base64Img: string, imgSignature: File, saveAndReload: Function, saveCoordinates: Function, activeOnSubit: Function, back: Function, isAndroid: boolean, isPhone: boolean, signatures: object[], currentPage: number, email: string, deleteSign: Function, signerData: {email: string, nameSigner: string, lastNameSigner: string, type: number, typeName: string, id_order: number, sendDocument: boolean, proofOfLife: boolean, numSign: number, is: string, isLastItem: string}, timestamp: string}} params
 * @return {*} 
 */
export default function P5ContainerCoordinates({
    tFunction,
    widthImg,
    heightImg,
    base64Img,
    imgSignature,
    widthImgSignature,
    heightImgSignature,
    save,
    saveAndReload,
    saveCoordinates,
    activeOnSubit,
    back,
    isAndroid,
    gotToEnd,
    isPhone,
    signatures,
    currentPage,
    email,
    deleteSign,
    signerData,
    timestamp
}) {
    if (activeOnSubit !== validation.activeOnSubit) {
        validation.activeOnSubit = activeOnSubit
    }
    const { t } = useTranslation()

    const p5Ref = useRef()
    const p5InstanceRef = useRef(null)

    /**
     * @param {p5.MediaElement} sketch
     */
    const Sketch = (sketch) => {
        let page = null
        let isSubmit = false
        let cancelBtn
        let signBtn
        let deleteBtnText
        let locateBtnText
        let signerNameText = ''
        let signerLastNameText = ''
        let timestampText = ''
        let deleteLocket
        let deletesignBtn
        let xRect = widthImg * 0.50
        let yRect = heightImg * 0.50
        let wRect = 206
        let hRect = 100
        let signature = null
        let overImage = false
        let locked = false
        let xOffSet = 0
        let yOffSet = 0
        let done = false
        let lockImg = null
        let unlockImg = null
        let isLock = false
        let savePostion = {}
        // Guardar referencias a todos los elementos DOM creados por p5 para limpiarlos explícitamente
        const uiElements = []

        /** @type {string[]} */
        let signerName = signerData.type === 1 ? signerData.nameSigner : signerData.nameCompleted

        let { twoLinesText, names: signerNames, lastNames: signerLastNames } = SignatureUtil.formatName(signerName)

        sketch.preload = () => {
            page = sketch.loadImage(base64Img)
            signature = sketch.loadImage(imgSignature)
            lockImg = sketch.loadImage(lock)
            unlockImg = sketch.loadImage(unlock)
        }

        function setLineDash(list) {
            sketch.drawingContext.setLineDash(list)
        }

        sketch.setup = () => {
            sketch.createCanvas(widthImg, heightImg + 70)
            sketch.textSize(15)
            sketch.noStroke()
            if (signatures) {
                for (let i = 0; i < signatures.length; i++) {
                    const item = signatures[i]
                    if (item.page === currentPage && item.email === email) {
                        deleteLocket = sketch.createImg(padlockLocked)
                        deletesignBtn = sketch.createImg(deleteButton)
                        deleteBtnText = sketch.createButton(tFunction('signatureRequestProfile.dialogLocate.deleteSign'))
                        uiElements.push(deleteLocket, deletesignBtn, deleteBtnText)
                        // Asegurar que los elementos pertenezcan al contenedor del componente (no al <body>)
                        if (p5Ref.current) {
                            deleteLocket.parent(p5Ref.current)
                            deletesignBtn.parent(p5Ref.current)
                            deleteBtnText.parent(p5Ref.current)
                        }


                        deleteBtnText.position(
                            item.x + 50,
                            -item.y + 150 + heightImg - hRect + (isPhone ? 55 : 0),
                            'relative '
                        )

                        deleteLocket.position(
                            item.x + 5,
                            -item.y + 120 + heightImg - hRect + (isPhone ? 55 : 0),
                            'relative '
                        )

                        deletesignBtn.position(
                            item.x + 155,
                            -item.y + 120 + heightImg - hRect + (isPhone ? 55 : 0),
                            'relative '
                        )

                        deleteLocket.class('canvasBtnSignLocket')
                        deletesignBtn.class('canvasBtnSignCoordinates canvasBtnTrash')
                        deleteBtnText.class('canvasBtnDeleteText')
                        deletesignBtn.mouseClicked(() => {
                            const filteredSigns = signatures.filter(item => item.email === email)
                            const indexInTheirCoordinates = filteredSigns.findIndex(item => (item.x === signatures[i].x) && (item.y === signatures[i].y) && (item.page === signatures[i].page))
                            deleteSign(indexInTheirCoordinates, i)
                        })
                    }
                }
            }
            cancelBtn = sketch.createButton(t('button.accept'))
            signBtn = sketch.createImg(padlickUnlocket)
            locateBtnText = sketch.createButton(tFunction('signatureRequestProfile.dialogLocate.locateSign'))
            uiElements.push(cancelBtn, signBtn, locateBtnText)
            if (p5Ref.current) {
                cancelBtn.parent(p5Ref.current)
                signBtn.parent(p5Ref.current)
                locateBtnText.parent(p5Ref.current)
            }

            if (widthImg < 550) {
                cancelBtn.position(
                    widthImg / 2 - 47.5 + 16 + 95 + 50 + 50,
                    heightImg + 200 + (isPhone ? 100 : 0)
                )
            } else {
                cancelBtn.position(
                    widthImg / 2 - 47.5 + 35 + 300,
                    heightImg + 170 - 13
                )
            }

            signBtn.position(
                xRect + 10,
                yRect + 121
            )

            locateBtnText.position(
                (xRect + 55),
                (yRect + 160)
            )

            signBtn.class('canvasBtnSignCoordinates canvasBtnLocket')
            locateBtnText.class('canvasBtnSignText')
            cancelBtn.class('canvasBtn')

            signBtn.mouseClicked(() => {
                let data = {
                    x: xRect,
                    y: yRect,
                    width: wRect,
                    height: hRect,
                    savePostion,
                }
                data.y = heightImg - data.y - data.height
                saveCoordinates(data)
                saveAndReload(data)
            })

            cancelBtn.mouseClicked(() => {
                back()
            })
        }
        sketch.draw = () => {
            let widthRect = wRect
            let heightRect = hRect
            let initX = xRect
            let initY = yRect
            sketch.background(220)
            sketch.fill('#005DA1')
            sketch.fill(255)
            sketch.image(page, 1, 2, widthImg - 2, heightImg - 2)

            if (
                sketch.mouseX >= initX + 5 &&
                sketch.mouseX <= initX + widthRect - 5 &&
                sketch.mouseY >= initY + 5 &&
                sketch.mouseY <= initY + heightRect - 5
            ) {
                sketch.cursor('grab')
                let isCurrent = false
                isCurrent = overImage || isCurrent
                if (!isCurrent && !done) overImage = true
            } else {
                sketch.cursor('context-menu')
                overImage = false
            }

            // sketch.image(signature, initX, initY, widthRect, heightRect)
            if (validation.activeOnSubit) {
                isSubmit = true
            }
            if (validation.activeOnSubit && isSubmit) {
                isSubmit = false
            }
            const squareColor = sketch.color('#BBDEFB')
            squareColor.setAlpha(100)
            sketch.fill(squareColor)
            sketch.stroke('#2196F3')
            setLineDash([5, 5]) //longer stitches
            sketch.rect(initX, initY, widthRect, heightRect)
            sketch.fill(255, 255, 255)
            sketch.stroke('#fff')
            sketch.rect(0, heightImg + 2, widthImg, 100)

            sketch.fill('#000000')
            sketch.textSize(11)
            sketch.textAlign(sketch.CENTER)
            if (twoLinesText) {
                sketch.text(signerNames, xRect + wRect / 2, yRect + 75)
                sketch.text(signerLastNames, xRect + wRect / 2, yRect + 85)
                sketch.text(timestamp, xRect + wRect / 2, yRect + 95)
            } else {
                sketch.text(signerName, xRect + wRect / 2, yRect + 85)
                sketch.text(timestamp, xRect + wRect / 2, yRect + 95)
            }
            sketch.textAlign(sketch.LEFT)
            // sketch.fill(0, 0, 0)
            if (signatures) {
                for (let i = 0; i < signatures.length; i++) {
                    const item = signatures[i]
                    if (item.page === currentPage && item.email === email) {
                        const squareColor = sketch.color('#B2EBF2')
                        squareColor.setAlpha(100)
                        sketch.fill(squareColor)
                        sketch.stroke('#00BCD4')
                        setLineDash([0]) //long line
                        sketch.rect(item.x, heightImg - item.y - item.height, wRect, hRect)
                    }
                }
            }
            if (isAndroid) {
                sketch.image(
                    isLock ? lockImg : unlockImg,
                    initX + widthRect * 0.9 - 13,
                    initY + 5,
                    26,
                    26
                )
            }
        }

        sketch.mousePressed = () => {
            if (
                sketch.mouseX >= xRect + 5 &&
                sketch.mouseX <= xRect + wRect - 5 &&
                sketch.mouseY >= yRect + 5 &&
                sketch.mouseY <= yRect + hRect - 5
            ) {
                sketch.cursor('grabbing')
            }
            if (isAndroid) {
                if (
                    xRect + wRect * 0.9 - 13 <= sketch.mouseX &&
                    xRect + wRect * 0.9 + 13 >= sketch.mouseX &&
                    yRect + 44 >= sketch.mouseY &&
                    yRect + 5 <= sketch.mouseY
                ) {
                    isLock = !isLock
                } else if (!isLock) {
                    xRect = sketch.mouseX - wRect / 2
                    yRect = sketch.mouseY - hRect / 2
                }
            } else {
                if (overImage) {
                    locked = true
                } else {
                    locked = false
                }
                xOffSet = sketch.mouseX - xRect
                yOffSet = sketch.mouseY - yRect
            }
        }

        sketch.mouseDragged = () => {
            if (locked) {
                xRect = sketch.mouseX - Math.floor(xOffSet)
                yRect = sketch.mouseY - Math.floor(yOffSet)

                // Limitar dentro de la imagen
                xRect = Math.max(0, Math.min(xRect, widthImg - wRect))
                yRect = Math.max(0, Math.min(yRect, heightImg - hRect))

                signBtn.position(
                    xRect + 10,
                    yRect + 121
                )

                locateBtnText.position(
                    (xRect + 55),
                    (yRect + 160)
                )
            }
        }

        sketch.mouseReleased = () => {
            locked = false

            xRect = sketch.mouseX - Math.floor(xOffSet)
            yRect = sketch.mouseY - Math.floor(yOffSet)

            // Limitar dentro de la imagen
            xRect = Math.max(0, Math.min(xRect, widthImg - wRect))
            yRect = Math.max(0, Math.min(yRect, heightImg - hRect))
        }

        // Exponer lista de elementos para limpieza
        sketch._uiElements = uiElements
    }

    useEffect(() => {
        // Antes de crear una nueva instancia, elimina la previa (defensivo si el componente se reutiliza)
        if (p5InstanceRef.current) {
            try {
                if (p5InstanceRef.current._uiElements) {
                    p5InstanceRef.current._uiElements.forEach(el => {
                        try { el.remove() } catch (_) { }
                    })
                }
                p5InstanceRef.current.remove()
            } catch (e) { /* noop */ }
            p5InstanceRef.current = null
        }
        // Limpia el contenedor por si quedaron nodos huérfanos
        if (p5Ref.current) {
            while (p5Ref.current.firstChild) {
                p5Ref.current.removeChild(p5Ref.current.firstChild)
            }
        }
        p5InstanceRef.current = new p5(Sketch, p5Ref.current)
        return () => {
            if (p5InstanceRef.current) {
                try {
                    if (p5InstanceRef.current._uiElements) {
                        p5InstanceRef.current._uiElements.forEach(el => {
                            try { el.remove() } catch (_) { }
                        })
                    }
                    p5InstanceRef.current.remove()
                } catch (e) { /* noop */ }
                p5InstanceRef.current = null
            }
        }
        // Solo crear una vez por montaje; si se requiere actualización dinámica de props se puede añadir dependencias específicas.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className='p5Container' ref={p5Ref} />
}